import React, { useState } from "react"
import { usePageAssets } from "hooks/usePageAssets"
import ContactSalesModal from "components/ContactSalesModal"
import { openModal } from "utils/openModal"
import Button from "components/ui/Button"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"
import SplitContainer from "components/ui/Layout/SplitContainer"

function HeroSection() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false)
  const { getAsset } = usePageAssets()
  const illustration = getAsset("mpc-hero-illustration-svg")
  return (
    <Container section>
      <SplitContainer
        className="pt-10 lg:py-10 xl:py-20"
        image={illustration}
        imageClassName="mx-auto max-w-xl md:-mt-[5%] lg:mt-0 scale-125 xl:scale-100 w-full"
      >
        <Heading
          level="h1"
          title="Increased security with Preset Managed Private Cloud"
          subtitle={
            <>
              Preset’s modern BI platform is available in your <b>AWS</b>,{" "}
              <b>GCP</b>, or <b>Azure</b> private cloud to meet your security
              and regulatory compliance requirements.
            </>
          }
          size="huge"
        />
        <Button
          className="mt-7"
          color="green"
          size="medium"
          href="/contact-sales/"
          onClick={openModal(setIsContactModalOpen)}
          trackClick="Contact Sales (hero)_Preset Managed Private Cloud"
          shadow
        >
          Talk to an Expert
        </Button>
      </SplitContainer>
      <ContactSalesModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
        sourcePage="MPC - Hero"
      />
    </Container>
  )
}

export default HeroSection
